import { observer } from 'mobx-react-lite';
import React from 'react';
import {
  Button,
  Card,
  CardContent,
  PageLayout,
  TimeSlot,
} from '../../../../components/shared';
import { useLanguage } from '../../../../hooks/shared';
import { useHomeTrainingMode } from '../../hooks';
import { TrainingNotFoundState } from '../states';

interface TrainingViewProps {
  isTrainingMode: boolean;
  trainingIdParam: string | undefined;
  eventInstanceStore: any;
  scheduleStore: any;
  userStore: any;
  format: (date: Date, formatStr: string) => string;
}

/**
 * Smart component for training view mode
 */
export const TrainingView: React.FC<TrainingViewProps> = observer(
  ({
    isTrainingMode,
    trainingIdParam,
    eventInstanceStore,
    scheduleStore,
    userStore,
    format,
  }) => {
    const { t } = useLanguage();

    // Use training mode hook internally
    const trainingData = useHomeTrainingMode(
      isTrainingMode,
      trainingIdParam,
      eventInstanceStore,
      scheduleStore,
      userStore,
      format
    );

    // Show loading state while training data is loading
    if (!trainingData) {
      return <TrainingNotFoundState onBack={() => window.history.back()} />;
    }

    const { training, currentSchedule } = trainingData;

    if (!training) {
      return <TrainingNotFoundState onBack={() => window.history.back()} />;
    }

    return (
      <PageLayout
        title={t('training.training')}
        subtitle={`${training.startTime} - ${training.endTime} • ${training.isTemplate ? format(training.startDateTime, 'EEEE') : format(training.startDateTime, 'd MMMM yyyy, EEEE')}${currentSchedule ? ` • ${currentSchedule.name}` : ''}`}
        icon="🏃‍♀️"
      >
        <Card className="shadow-xl">
          <CardContent className="p-6">
            <div className="max-w-2xl mx-auto">
              {/* Back button */}
              <div className="mb-6">
                <Button
                  variant="outline"
                  onClick={() => window.history.back()}
                  className="flex items-center gap-2"
                >
                  <span>←</span>
                  {t('common.back')}
                </Button>
              </div>

              <TimeSlot
                training={training}
                hideTime={true}
                showTemplateDescription={true}
                className="ring-4 ring-blue-500 ring-opacity-50 shadow-lg"
              />
            </div>
          </CardContent>
        </Card>
      </PageLayout>
    );
  }
);
